export let CmsAltMenuGroup;
(function (CmsAltMenuGroup) {
  CmsAltMenuGroup["EditorList"] = "editor-list";
  CmsAltMenuGroup["EditorImageMarkers"] = "editor-image-markers";
})(CmsAltMenuGroup || (CmsAltMenuGroup = {}));